import React, { useCallback, useEffect, useState } from "react";
import "./EditCountry.css";
import Header from "../header/Header";
import {
  getAllFields,
  AddCountry,
  getAllCountries,
} from "../../services/ApiService";
import { Button, AutoComplete, Checkbox, Row, Col, message } from "antd";
import Sidebar from "../Sidebar/Sidebar";

const EditCountry = () => {
  const [fields, setFields] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [checkedFields, setCheckedFields] = useState([]);
  const [countryInput, setCountryInput] = useState(""); // new state

  const fetchCountries = async () => {
    try {
      const res = await getAllCountries(0);
      if (res.responseCode === 200) {
        setCountries(res.country_list);
      } else {
        throw new Error("Failed to fetch fields");
      }
    } catch (error) {
      console.error("Error fetching fields:", error);
      message.error("Failed to fetch fields");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fieldsRes = await getAllFields();
        if (fieldsRes.response_code === 200) {
          setFields(fieldsRes.field_list);
        }

        fetchCountries();
      } catch (error) {
        console.error("Error fetching fields and countries:", error);
      }
    };

    fetchData();
  }, []);

  const handleCountrySelect = (value) => {
    setCountryInput(value);
    const countryData = countries.find(
      (country) => country.country_name === value
    );
    if (!countryData) {
      setSelectedCountry(null);
      setCheckedFields([]);
      return;
    }
    setSelectedCountry(countryData);
    setCheckedFields([]);
  };

  const handleCheckboxChange = useCallback((e, fieldId) => {
    setCheckedFields((prevCheckedFields) =>
      e.target.checked
        ? [...prevCheckedFields, fieldId]
        : prevCheckedFields.filter((id) => id !== fieldId)
    );
  }, []);

  const handleAdd = async () => {
    try {
      if (checkedFields.length === 0) {
        message.error("At least one field is required.");
        return;
      }

      const body = {
        country_id: selectedCountry.id,
        form_field: checkedFields.join(","),
      };

      const res = await AddCountry(body);
      if (res.responseCode === 200) {
        message.success("Country Added Successfully");
        setCheckedFields([]);
        setSelectedCountry(null);
        setCountryInput(""); // reset input field
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error("Error adding country");
      console.error("Error adding country:", error);
    }
  };

  return (
    <>
      <div className="main-box">
        <Sidebar activeId={2} />
        <main className="main-content">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
            }}
          >
            <Header title="Country Management" />
            <div
              style={{
                flex: 1,
                padding: "2rem",
                boxSizing: "border-box",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="country-box">
                <div>
                  <p
                    style={{
                      fontFamily: "DM Sans",
                      fontSize: "1rem",
                      fontWeight: 700,
                      marginTop: 0,
                    }}
                  >
                    Choose Country
                  </p>
                  <AutoComplete
                    placeholder="Select Country"
                    className="country-select"
                    style={{ width: 200 }}
                    value={countryInput}
                    onSearch={(text) => setCountryInput(text)}
                    onSelect={handleCountrySelect}
                    options={countries.map((country) => ({
                      value: country.country_name,
                    }))}
                    filterOption={(inputValue, option) =>
                      option.value
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                  />
                  {selectedCountry && (
                    <Button
                      type="primary"
                      onClick={handleAdd}
                      style={{ marginLeft: "2rem" }}
                    >
                      Add Country
                    </Button>
                  )}
                </div>
              </div>
              {selectedCountry && (
                <>
                  <p
                    style={{
                      fontSize: "0.8rem",
                      color: "#5C5D61",
                      fontFamily: "Inter",
                      fontWeight: 500,
                    }}
                  >
                    Choose the fields needed for onboarding below. You can edit
                    them later in settings.
                  </p>
                  <div
                    className="country-field"
                    style={{
                      marginTop: "1rem",
                      height: "60vh",
                      overflowY: "auto",
                    }}
                  >
                    <Row
                      gutter={[16, 16]}
                      className="custom-scrollbar"
                      style={{
                        height: "100%",
                        overflowY: "auto",
                      }}
                    >
                      {fields?.map((field) => (
                        <Col span={12} key={field.id}>
                          <Checkbox
                            value={field.id}
                            checked={checkedFields.includes(field.id)}
                            onChange={(e) => handleCheckboxChange(e, field.id)}
                          >
                            {field.name}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </>
              )}
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default EditCountry;
